export default __webpack_public_path__ + "static/media/drawingadd.9439cf7a.jpg";